import { render } from "./GearLoader.vue?vue&type=template&id=2e40a586&scoped=true"
import script from "./GearLoader.vue?vue&type=script&lang=js"
export * from "./GearLoader.vue?vue&type=script&lang=js"

import "./GearLoader.vue?vue&type=style&index=0&id=2e40a586&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e40a586"]])

export default __exports__